import React, { useEffect, useRef, useState } from 'react'
import styles from './FormInput.module.scss'
import FormattedMessage from '../../helpers/FormattedMessage'
import { useOutsideAlerter } from '../../helpers/useHandleOutsideClick'
import arrowIcon from '../../assets/icons/icn-arrow-horizontal.svg'
import checkIcon from '../../assets/icons/icn_check_green.png'
import { useIntl } from 'react-intl'

interface IProps {
  title: string
  placeholder: string
  onChange: (value: string) => void
  value: string
  type?: string
  validation?: RegExp
  select?: {
    id: string | null
    name: string
    __typename: string
  }[]
  selectDefault?: string
  validationCheck: boolean
}

export const FormInput = ({
  title,
  type,
  value,
  validation,
  onChange,
  placeholder,
  select,
  selectDefault,
  validationCheck,
}: IProps) => {
  const ref = useRef(null)
  const [state, setState] = useState(value)
  const [filterValue, setFilterValue] = useState('')
  const [selectValue, setSelectValue] = useState(select ? select.filter((item) => item.id === value)[0]?.name : '')
  const [isError, setIsError] = useState(false)
  const [isSelectOpen, setIsSelectOpen] = useState(false)
  const intl = useIntl()

  // var valid = false

  useEffect(() => {
    if (validationCheck) {
      if (validation?.test(state)) {
        setIsError(false)
      } else {
        setIsError(true)
      }
    }
  }, [validationCheck, state, validation])

  useOutsideAlerter({
    ref,
    onClick: () => {
      if (select) {
        setIsSelectOpen(false)
      }
    }
  })

  const toggle = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    setIsSelectOpen(state => !state)
  }

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState(e.target.value)
    onChange(e.target.value)
    if (validation?.test(e.target.value)) {
      setIsError(false)
    } else {
      setIsError(true)
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleFilterValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterValue(e.target.value)
  }

  const getFilteredArr = () => {
    const res = select?.filter((item) => item.name.includes(filterValue))

    selectDefault && res && (res.length <= 4)
      && res?.push({ id: '0', name:  intl.formatMessage({ id: selectDefault }), __typename: "m2SchoolInterface"})

    return res
  }

  return (
    <div className={`${styles.Wrapper} ${isError && styles.Error}`}>
      <div className={styles.FormItem} onClick={select && toggle} ref={ref}>

        {/* {select && <img src={manifyIcon} className={styles.MagnifyIcon}/>} */}

        <div className={styles.InfoContainer}>
          <h4 className={`${styles.Title} ${isError && styles.Error}`}>
            <FormattedMessage id={title}/>
            {isError ?
              state === ''
                ? <span> - <FormattedMessage id='empty'/></span>
                  : <span> - <FormattedMessage id='wrongFormat'/></span>
              : null
            }
          </h4>
          {!select &&
          <input
              autoComplete={type === 'email' ? type : "on"}
              name={title}
              type={type ? type : 'text'}
              value={state}
              placeholder={placeholder}
              onChange={onInputChange}
          />}
          {!select && validation?.test(state) && <img src={checkIcon} className={styles.CheckIcon} alt="valid"/> }

          {select &&
          <>
            <span className={!selectValue ? styles.Placeholder : ''}>
              {selectValue ? selectValue : placeholder}
            </span>
            {isSelectOpen &&
            <div className={styles.SelectContent}>
              {(filterValue ? getFilteredArr() : select)?.map((item) => (
                <div className={styles.SelectItem} key={item.id} onClick={(e) => {
                  toggle(e)
                  setState(`${item.name}`)
                  setSelectValue(item.name)
                  onChange(`${item.name}`)
                }}>
                  {item.name}
                </div>
              ))}
            </div>
            }
          </>
          }
        </div>
        {select && <img className={styles.Rorate} src={arrowIcon} alt="arrow"/>}
      </div>
    </div>
  )
}
